export default {
  UltimateAdmin: 'UltimateAdministrator',
  CompanyAnnouncer: 'CompanyAnnouncer',
  DepartmentAnnouncer: 'DepartmentAnnouncer',
  BannerAdmin: 'BannerAdministrator',
  PolicyAdmin: 'PolicyAdministrator',
  MAYOFormAdmin: 'MAYOFormAdmin',
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/configs/role.js
 **/